import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { AppRoutes } from "../../Constants/AppRoutes";
import { GlobalState } from "../../Redux/RootReducer";
import "./NotFoundPage.scss";

const NotFoundPage = () => {
  const loggedUser = useSelector((s: GlobalState) => s.generic.user);

  return (
    <div>
      <div className="center-content fill-page-height not-found-medical-background">
        <div className="card smooth-background">
          <div className="not-found-main-wrap">
            <div className="not-found-title">OPS! Pagina non trovata!</div>
            <div className="not-found-number">404</div>
            <div className="not-found-sub-title">
              {loggedUser === undefined && (
                <div>
                  La pagina che stai cercando <strong>non esiste</strong>,
                  oppure richiede che tu{" "}
                  <Link to={AppRoutes.APP_LOGIN_PAGE}>esegua l'accesso</Link>{" "}
                  per essere visitata.
                </div>
              )}
              {loggedUser && (
                <div>
                  La pagina che stai cercando <strong>non esiste</strong>. Torna
                  alla{" "}
                  <Link to={AppRoutes.APP_ALARMS_PAGE}>
                    pagina degli allarmi
                  </Link>
                  .
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
